export const imageUrlToCanvasImage = async (url, coordinate) => {
    return new Promise(async (resoleve, reject) => {
        try {
            const image = await getImageData(url);
            let canvas = await createCanvas(image,coordinate)
            resoleve(canvas.toDataURL())
        } catch (error) {
            console.log('getImageData-->error', error)
        }
    })
}

const createCanvas = async (image, coordinate) => {
    const { x, y, w, h } = coordinate;
    const canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext("2d")
    ctx.drawImage(image, x,y, w,h,0,0,w,h);
    return canvas;
}

export const getImageData = (url) => {
    return new Promise((resolve, reject) => {
         const image = new Image()
         image.onload = () => {
             resolve(image)
        }
        image.onerror = (err => {
            reject(err)
        })
        image.crossOrigin = 'anonymous'
        image.src = url
    })
}

